module.exports = __webpack_public_path__ + "media/dogs/loading-dog-7cd84290.svg";